export default __webpack_public_path__ + "locales/lo-LA/ResetApplicationDialog.json?hash=8f47f22368699edab0d6c1a2fa8fd65d";